import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Item } from './item';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class ItemService {
	
baseUrl = environment.baseUrl;

  private itemsUrl = this.baseUrl + '/api/items';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getItems (): Observable<Item[]> {
    return this.http.get<Item[]>(this.itemsUrl)
  }
  
  getItem(itemid: number): Observable<Item> {
    const url = `${this.itemsUrl}/${itemid}`;
    return this.http.get<Item>(url);
  }
 
  addItem (item: Item): Observable<Item> {
    return this.http.post<Item>(this.itemsUrl, item, httpOptions);
  }
 
  deleteItem (item: Item | number): Observable<Item> {
    const id = typeof item === 'number' ? item : item.itemid;
    const url = `${this.itemsUrl}/${id}`;
 
    return this.http.delete<Item>(url, httpOptions);
  }
 
  updateItem (item: Item): Observable<any> {
    return this.http.put(this.itemsUrl, item, httpOptions);
  }
}